import Dexie from 'dexie';
import {
    getIndexedData,
    initDataCollection,
    addSuggestion,
    updateSuggeestion,
    resetSuggestion
} from '../../features/Personalization/service/indexDBPersonalizarionCenterService';
import {
    SnoozedSuggestion,
    CenterData,
    SuggestionType
} from '../../features/Personalization/types/personalizationCenter';
import {personalizationCenterRef} from '../../features/Personalization/components/PresonalizationCenter.root';

export class PersonalizationCenter extends Dexie {
    public centerData: Dexie.Table<CenterData>;

    constructor() {
        super('PersonalizationCenter');
        this.version(1).stores({
            centerData: '[userName+company], centerData'
        });
    }
}

export const db = new PersonalizationCenter();

export const addSoonzedSuggestion = async (snoozedSuggestion: SnoozedSuggestion) => {
    const indexedData = await getIndexedData(db);
    if (!indexedData) {
        await initDataCollection(db, snoozedSuggestion);
    } else {
        const {data} = indexedData;
        const suggestionIndex = data.findIndex(
            (s: SnoozedSuggestion) => s.type === snoozedSuggestion.type
        );
        if (suggestionIndex < 0) {
            await addSuggestion(db, snoozedSuggestion);
        } else {
            await updateSuggeestion(db, suggestionIndex, snoozedSuggestion);
        }
    }
    personalizationCenterRef.current.reloadData();
};

export const resetPersonalizationSuggestion = async (suggestionType: SuggestionType) => {
    const indexedData = await getIndexedData(db);
    const index = indexedData.data?.findIndex(s => s.type === suggestionType);
    if (index >= 0) {
        await resetSuggestion(db, index);
        personalizationCenterRef.current.reloadData();
    }
};
